import React from "react";
import {
    BlockQuote,
    GoToAction,
    Cite,
    Deck,
    Heading,
    ListItem,
    List,
    Quote,
    Slide,
    Text
} from "spectacle";

const AboutAltola = () =>
    <div>
        <Heading size={6} textColor="fifth" caps>
            a boutique digital experience agency
        </Heading>
        <List textColor="primary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={30}>25+ yrs experience of deep and diverse content and experience marketing </ListItem>
            <ListItem textSize={30}>San Francisco based</ListItem>
        </List>
        <Heading size={6} textColor="fifth" caps>
            Specialties
        </Heading>
        <List textColor="primary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={30}>content management, omni-channel tracking, analytics, and delivery</ListItem>
            <ListItem textSize={30}>personalization and analytics</ListItem>
            <ListItem textSize={30}>creating connected digital experiences</ListItem>
        </List>
    </div>

export default AboutAltola;


// WEBPACK FOOTER //
// ./src/slides/AboutAltola.js